module.exports = {
	"title": "New Arrivals for You",
	"viewAll": "View All"
};


//////////////////
// WEBPACK FOOTER
// ./assets/js/home/components/personalization/personalizationCopy.json
// module id = 2027
// module chunks = 22